import gql from 'graphql-tag';
import history from '../../history';
import { setLoaderStart, setLoaderComplete } from '../../actions/loader/loader';
import showToaster from '../../helpers/showToaster';

export function editVehicle(id, vehicleName, vehicleType, vehicleNumber, vehicleStatus, vehicleColor, isChildSeatAvailable, isWheelChairAvailable) {

    return async (dispatch, getState, { client }) => {
        const mutation = gql`
            mutation updateVehicle($id: Int, $vehicleName: String, $vehicleType: Int, $vehicleNumber: String, $vehicleStatus: String, $vehicleColor: String, $isChildSeatAvailable: Boolean, $isWheelChairAvailable: Boolean) {
                updateVehicle(
                id: $id
                vehicleName: $vehicleName,
                vehicleType: $vehicleType
                vehicleNumber: $vehicleNumber,
                vehicleStatus: $vehicleStatus
                vehicleColor: $vehicleColor
                isChildSeatAvailable: $isChildSeatAvailable
                isWheelChairAvailable: $isWheelChairAvailable
                ){
                status
                }
            }
        `;

        const query = gql`
            query getAllVehicles($currentPage: Int){
                getAllVehicles(currentPage: $currentPage){
                count
                vehicleData{
                    id
                    vehicleType
                    vehicleNumber
                    vehicleName 
                    vehicleStatus
                    vehicleColor
                    isChildSeatAvailable
                    isWheelChairAvailable
                    category{
                        categoryName
                    }
                    user{
                        email
                        profile{
                        firstName
                        }
                    }
                }
                }
            }
        `;
        dispatch(setLoaderStart('EditVehicle'));

        const { data } = await client.mutate({
            mutation,
            variables: {
                id,
                vehicleName,
                vehicleType,
                vehicleNumber,
                vehicleStatus,
                vehicleColor,
                isChildSeatAvailable,
                isWheelChairAvailable
            },
            refetchQueries: [{
                query,
                variables: {
                    currentPage: 1
                }
            }]
        })
        dispatch(setLoaderComplete('EditVehicle'));

        if (data && data.updateVehicle && data.updateVehicle.status === 200) {
            history.push('/siteadmin/vehicles')
            showToaster({ messageId: 'updateVehicle', toasterType: 'success' })
        } else if (data && data.updateVehicle && data.updateVehicle.status === 400) {
            history.push('/siteadmin/vehicles');
            showToaster({ messageId: 'updateVehicleError', toasterType: 'error' })
        } else {
            history.push('/siteadmin/vehicles');
            showToaster({ messageId: 'commonError', toasterType: 'error' })
        }
    }
}